import { MigrationManifest, PersistedState } from 'redux-persist';

import * as services from './services';

/**
 * Las cachés de RTK Query, una por servicio. No se guardan en el navegador:
 * una consulta guardada a media descarga queda en `pending`, y RTK Query no
 * vuelve a pedir lo que cree que ya está en curso. Con el catálogo de
 * propiedades eso dejaba al vendedor sin poder entrar en ninguna recarga hasta
 * borrar los datos del sitio (VWA-43).
 *
 * Se sacan del barrel de servicios para que un `createApi` nuevo quede fuera
 * sin tener que acordarse de agregarlo aquí.
 */
export const API_REDUCER_PATHS: string[] = Object.values(
  services as Record<string, unknown>,
)
  .filter(
    (exported): exported is { reducerPath: string } =>
      typeof exported === 'object' &&
      exported !== null &&
      'reducerPath' in exported,
  )
  .map(api => api.reducerPath);

/** Versión del estado guardado; sube con cada migración. */
export const PERSIST_VERSION = 2;

/**
 * Migraciones del estado guardado, por versión de destino.
 *
 * La lista negra de redux-persist solo filtra lo que se escribe: al rehidratar
 * aplica todo lo que encuentre guardado. Por eso las cachés que ya estaban en
 * el navegador se quitan aquí, una vez. Cada migración quita solo lo suyo: una
 * que devolviera un estado vacío cerraría la sesión de todos los vendedores.
 */
export const persistMigrations: MigrationManifest = {
  2: (state: PersistedState): PersistedState => {
    if (!state) return state;
    const rest: Record<string, unknown> = { ...state };
    API_REDUCER_PATHS.forEach(path => delete rest[path]);
    return rest as PersistedState;
  },
};
